import React, { useLayoutEffect, useState, useEffect, useReducer } from 'react';
import { useFetcher, useNavigate, } from "react-router-dom";
import axios from 'axios';
import { Helmet } from 'react-helmet';

// Custom Components
import LoginForm from "../components/Login/LoginForm";
import SignupForm from '../components/Login/SignupForm';
import PasswordRecoveryForm from '../components/Login/PasswordRecoveryForm';
import VerificationForm from '../components/Login/VerificationForm';

// React-reveal for animations
import Fade from 'react-reveal/Fade';

// Custom Styling
import "./LoginStyles.css";

import { LOGIN_STATES } from '../data/Login/LoginStates';
import { ROUTES } from '../data/GeneralData';
import { LoginReducer } from '../data/Login/LoginReducer';
import { INITIAL_STATE } from '../components/Apply/ApplicationStateTemplate';

axios.defaults.withCredentials = true;

function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}

export default function Login(props) {
    const pseudoNavigate = (url) => {
        // window.history.pushState(state, unused, url);
        window.history.pushState({ path: url }, '', url);
    };
    const userData = props.userData;
    const [width, height] = useWindowSize();
    const [loginState, setLoginState] = useState(props.loginState);
    const initialDocumentTitle = props.loginState === LOGIN_STATES.LOGIN ? "Login" :
    props.loginState === LOGIN_STATES.SIGNUP ? "Signup" : "Recover Password";

    // Reducer
    const [state, dispatch] = useReducer(LoginReducer, {
        ...INITIAL_STATE,
    });

    let navigate = useNavigate();

    // useEFfect hook for updating information based on login state

    useEffect(() => {
        switch (loginState) {
            case LOGIN_STATES.LOGIN: {
                pseudoNavigate(ROUTES.LOGIN);
                window.document.title = "Login | Hearts Unite";
                break;
            }
            case LOGIN_STATES.SIGNUP: {
                pseudoNavigate(ROUTES.SIGNUP);
                window.document.title = "Signup | Hearts Unite";
                break;
            }
            case LOGIN_STATES.FORGOT: {
                pseudoNavigate(ROUTES.FORGOT_PASSWORD);
                window.document.title = "Recover Password | Hearts Unite";
                break;
            }
        }
    }, [loginState]);

    const updateReducerState = (field, input) => {
        dispatch({ type: 'UPDATE_FIELD', field: field, value: input });
    };


    // Renders
    const renderLoginState = () => {
        if (userData) {
            if (!userData.verified) {
                return <VerificationForm />
            } else {
                return navigate("/dashboard");
            }

        } else {
            switch (loginState) {
                case LOGIN_STATES.LOGIN: {
                    return (
                        <LoginForm
                            loginEmail={state.loginEmail} loginPassword={state.loginPassword}
                            loginError={state.loginError} loginErrorMessage={state.loginErrorMessage}
                            setLoginState={setLoginState} updateReducerState={updateReducerState} />
                    )
                }

                case LOGIN_STATES.SIGNUP: {
                    return (
                        <SignupForm signupEmail={state.signupEmail} signupPassword={state.signupPassword}
                            signupPasswordConfirm={state.signupPasswordConfirm} fName={state.firstName} lName={state.lastName}
                            setLoginState={setLoginState} updateReducerState={updateReducerState} />
                    )
                }

                case LOGIN_STATES.FORGOT: {
                    return (
                        <PasswordRecoveryForm email={state.forgotEmail} verifyEmail={state.verifyForgotEmail}
                            emailSent={state.forgotEmailSent} forgotPasswordError={state.forgotPasswordError}
                            forgotPasswordErrorMessage={state.forgotPasswordErrorMessage}
                            setLoginState={setLoginState} updateReducerState={updateReducerState} />
                    )
                }
            }
            return (
                <>
                    <Fade delay={150}>
                        <div className="login-container">
                            <LoginForm loginState={loginState} />
                        </div>
                    </Fade>
                </>
            )
        }
    }

    const renderLoginImage = () => {
        if (width > 925) {
            return (
                <div className='login-image'>
                    <Fade>
                        <img className="hugs-logo-login" src="/images/logos/new-logo-white.png" />
                    </Fade>
                </div>
            )
        }
    };

    return (
        <>
            <div className="login">
                <Helmet>
                    <title>{initialDocumentTitle} | Hearts Unite</title>
                    {/* Limits User Zoom */}
                    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
                    <meta name="description" content="Login to your Hearts Unite to Give Support dashboard for tracking and reviewing applications for financial assistance." />
                    <meta property="og:title" content="Login | Hearts Unite" />
                    <meta property="og:image" content="/images/logos/new-logo-white.png" />
                </Helmet>


                <div className='login-flexbox'>

                    {renderLoginImage()}

                    {renderLoginState()}

                </div>

            </div>

        </>


    )
}